module.exports = __webpack_public_path__ + "static/media/INGMeWeb-Regular.9531ef57.woff";